import type { CSSProperties } from "react";
import type { Tag } from "../types";

import { tagIcons } from "../lib/tag-icons";

export function TagPill({ tag }: { tag: Tag }) {
  const icon = tagIcons[tag.icon_name ?? ""] ?? "#";

  return (
    <span className="tag-pill" style={{ "--tag-color": tag.icon_color ?? "#a970ff" } as CSSProperties}>
      <i aria-hidden="true">{tag.icon_url ? <img src={tag.icon_url} alt="" width={20} height={20} /> : icon}</i>
      {tag.name}
    </span>
  );
}
